import {
  createContext,
  useMemo,
  useCallback,
  useState,
  useContext,
} from "react";
import { IthemeProviderProps } from "../utils";

interface IDrawerOption {
  path: string;
  icon: string;
  label: string;
  subMenu?: {
    path: string;
    icon: string;
    label: string;
    subMenu?: any[];
  }[];
}

interface IdrawerContextData {
  isDrawerOpen: boolean;
  drawerOption: IDrawerOption[];
  toggleDrawerOpen: () => void;
  setDrawerOption: (newDrawerOption: IDrawerOption[]) => void;
}

const DrawerContext = createContext<IdrawerContextData>(
  {} as IdrawerContextData
);

export const useAppDrawerContext = () => {
  return useContext(DrawerContext);
};

export function DrawerProvider({ children }: IthemeProviderProps) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [drawerOption, setDrawerOption] = useState<IDrawerOption[]>([]);
  const toggleDrawerOpen = useCallback(() => {
    setDrawerOpen((oldDrawerOpen) => !oldDrawerOpen);
  }, []);

  const handleDrawerOpitions = useCallback(
    (newDrawerOption: IDrawerOption[]) => {
      setDrawerOption(newDrawerOption);
    },
    []
  );

  return (
    <DrawerContext.Provider
      value={{
        isDrawerOpen,
        toggleDrawerOpen,
        drawerOption,
        setDrawerOption: handleDrawerOpitions,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}
